import script from "./WurthProductInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./WurthProductInfo.vue?vue&type=script&setup=true&lang=js"

import "./WurthProductInfo.vue?vue&type=style&index=0&id=34da378b&lang=css"

const __exports__ = script;

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QCard,QCardSection,QBtn,QInput,QIcon,QImg});
